import { useTranslation } from 'react-i18next';
import { React, useState, useContext } from 'react';
import imageCompression from "browser-image-compression";
import { AppContext } from '../../../services/AppContext';
import { copyToClipboard } from '../../../services/Clipboard';

const EditCustomer = ({ closeModal, customerDto }) => {
    const { t } = useTranslation();
    const { apiClient, setIsLoading, notify } = useContext(AppContext);
    const [customer, setCustomer] = useState(customerDto);

    const handleResetPassword = async (id) => {
        const response = await apiClient.requestPasswordChange({
            userId: id
        });
        if (response.token) {
            const resetLink = window.env.REACT_APP_WEB_URL + '/reset-password?token=' + response.token;
            copyToClipboard(resetLink);
        }
    };

    const handleSaveCustomer = async () => {
        setIsLoading(true);

        const formData = new FormData();
        formData.append('id', customer.id || '');
        formData.append('name', customer.name || '');
        formData.append('username', customer.username || '');
        formData.append('phone', customer.phone || '');
        formData.append('notes', customer.notes || '');

        try {
            if (customer.picture) {
                const options = {
                    maxSizeMB: 0.1, // Maximum size in MB
                    maxWidthOrHeight: 512, // Maximum width/height in pixels
                    useWebWorker: true, // Enable web worker for better performance
                };
                const compressedFile = await imageCompression(customer.picture, options);
                formData.append('picture', compressedFile);
            }

            const result = await apiClient.updateUser(formData);

            if (result.hasErrors) {
                return;
            }
            closeModal(true);

            notify(t('pages.customers.modals.successMessage'), 'success');
            setCustomer({});
        } catch (error) {
            notify(error.message, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        closeModal(false);
        setCustomer({});
    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'picture') {
            setCustomer((prev) => ({
                ...prev,
                [name]: files[0], // Store the selected file
            }));
        } else {
            setCustomer((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    return (<div className="modal">
        <div className="modal-content">
            <h3>{t('pages.customers.modals.editCustomer')}</h3>
            <input
                type="text"
                name="name"
                placeholder={t('pages.customers.modals.namePlaceholder')}
                value={customer.name}
                onChange={handleChange}
            />
            <input
                type="text"
                name="phone"
                placeholder={t('pages.customers.modals.phonePlaceholder')}
                value={customer.phone || ''}
                onChange={handleChange}
            />
            <input
                type="text"
                name="notes"
                placeholder={t('pages.customers.modals.notesPlaceholder')}
                value={customer.notes || ''}
                onChange={handleChange}
            />
            <input
                type="file"
                name="picture"
                accept="image/*" // Restrict file selection to images
                onChange={handleChange}
            />
            <input
                type="text"
                name="username"
                placeholder={t('pages.customers.modals.usernamePlaceholder')}
                value={customer.username}
                onChange={handleChange}
            />

            <button className='background-warning width-100p mg-b-1' onClick={() => handleResetPassword(customer.id)}>{t('pages.customers.modals.resetPassword')}</button>

            <div className='container'>
                <button className='mg-r-1 width-100p' onClick={handleSaveCustomer}>{t('pages.customers.modals.saveButton')}</button>
                <button className='width-100p' onClick={handleCancel}>{t('pages.customers.modals.cancelButton')}</button>
            </div>
        </div>
    </div>
    )
};

export default EditCustomer;